<app-topnav [llttfPage]="llttfPage"></app-topnav>

<div class="view-course-desktop">
  <div class="container">

    <div class="participant-course-basic-details">

      <div class="course-metadata">
        <span class="course-thumbnail">
          <img [src]="imageURL" class="thumbnail">
        </span>
        <span class="participant-course-name">
          <span class="course-name-container">
            <h2>
              {{course.courseName}}
              <app-favourite-course [course]="course" [userId]="loggedInUserPublicId" (notifyParent)="handleFavouriteClick()"></app-favourite-course>
            </h2>
          </span>
          <div class="participant-course-short-description" [innerHTML]="course.courseShortDescription"></div>

          <app-tags [items]="course.tagList"></app-tags>
        </span>

        <span class="course-status negative-top-margin-30">
          <app-course-enrollment-status [course]="course"></app-course-enrollment-status>
          <app-retired-course [course]="course"></app-retired-course>

          <div class="form-buttons course-buttons">
            <button class="submit-form-button" [ngClass]="participantClassByRole" [hidden]="!course.isResumeCourseVisible" (click)="resumeCourse()">{{'resumeCourseText'|translate:translations}}</button>
            <button class="submit-form-button" [ngClass]="participantClassByRole" [hidden]="!course.isStartCourseVisible" (click)="startCourse()">{{'startCourseText'|translate:translations}}</button>
            <button class="submit-form-button" [ngClass]="participantClassByRole" [hidden]="!isViewCourseVisible" (click)="resumeCourse()">{{'viewCourseText'|translate:translations}}</button>
            <button class="submit-form-button cancel-button" [ngClass]="participantClassByRole" (click)="createPlan()">{{'createAPlanHeadingText'|translate:translations}}</button>
          </div>
        </span>
      </div>

    </div>

  </div>
  <div class="h-30"></div>
  <div class="participant-course-description-container">
    <div class="container">
      <!-- <div class="participant-course-description-details" *ngIf="course.retired"> -->
      @if (course.courseRetirement) {
        <div class="participant-course-description-details">
          <span class="course-info course-retired-notice">
            <h4><strong>{{'courseRetiredTitleText'|translate:translations}}</strong></h4>
            <span>{{ getCourseRetiredDetail() }}</span>
          </span>
        </div>
      }
      <div class="participant-course-description-details">
        <span class="course-info pb-30">
          <h4><strong>{{'aboutThisCourseText'|translate:translations}}</strong></h4>
          <span [innerHTML]="course.courseDescription"></span>
        </span>
        <span class="course-content">
          <div class="course-content-details">
            <h4><strong>{{'courseContentsText'|translate:translations}}</strong></h4>
            <ol>
              @for (content of coursematerial; track content) {
                <li>{{content.materialName}}
                  @if (content.isMaterialRetired) {
                    <span class="material-retired-meta">
                      <span class="material-retired-tag">{{ 'materialRetiredBadge' | translate: translations }}</span>
                      <app-information-popup [information]="materialRetiredPopupHtml(content)"></app-information-popup>
                    </span>
                  }
                </li>
              }
            </ol>
          </div>
        </span>
      </div>
    </div>
  </div>
</div>



<div class="view-course-mobile">
  <div class="container">

    <div class="course-actions">
      <div class="status-bar">
        <app-course-enrollment-status [course]="course"></app-course-enrollment-status>
        <app-retired-course [course]="course"></app-retired-course>
        <app-favourite-course [course]="course" [userId]="loggedInUserPublicId" (notifyParent)="handleFavouriteClick()"></app-favourite-course>
      </div>
      <div class="h-30"></div>

      <h2>{{course.courseName}}</h2>
      <div class="participant-course-short-description" [innerHTML]="course.courseShortDescription"></div>
      <app-tags [items]="course.tagList"></app-tags>
      <div class="h-30"></div>

      <span class="course-thumbnail">
        <img [src]="imageURL" class="thumbnail">
      </span>

      <div class="form-buttons justify">
        <button class="submit-form-button" [ngClass]="participantClassByRole" [hidden]="!course.isResumeCourseVisible" (click)="resumeCourse()">{{'resumeCourseText'|translate:translations}}</button>
        <button class="submit-form-button" [ngClass]="participantClassByRole" [hidden]="!course.isStartCourseVisible" (click)="startCourse()">{{'startCourseText'|translate:translations}}</button>
        <button class="submit-form-button" [ngClass]="participantClassByRole" [hidden]="!isViewCourseVisible" (click)="resumeCourse()">{{'viewCourseText'|translate:translations}}</button>
        <button class="submit-form-button cancel-button" [ngClass]="participantClassByRole" (click)="createPlan()">{{'createAPlanHeadingText'|translate:translations}}</button>
      </div>
    </div>

  </div>
  <div class="h-30"></div>
  <div class="participant-course-description-container">
    <div class="container">
      <div class="participant-course-description-details">

        <span class="course-info pb-30">
          <div class="h-30"></div>
          <h4><strong>{{'aboutThisCourseText'|translate:translations}}</strong></h4>
          <span [innerHTML]="course.courseDescription"></span>
        </span>
        <span class="course-content">
          <div class="course-content-details">
            <h4><strong>{{'courseContentsText'|translate:translations}}</strong></h4>
            <ol>
              @for (content of coursematerial; track content) {
                <li>{{content.materialName}}
                  @if (content.isMaterialRetired) {
                    <span class="material-retired-meta">
                      <span class="material-retired-tag">{{ 'materialRetiredBadge' | translate: translations }}</span>
                      <app-information-popup [information]="materialRetiredPopupHtml(content)"></app-information-popup>
                    </span>
                  }
                </li>
              }
            </ol>
          </div>
        </span>
      </div>
    </div>
  </div>
</div>

<app-footer [bbapp]="true" [extraClass]="flushed"></app-footer>
